/**
 * turnus.ai brand palette — raw brand hex values for code that needs them
 * outside Tailwind (e.g. the chat PDF export's print iframe). Tailwind reads
 * the same palette from the @theme block in src/index.css; brandColors.test.ts
 * fails if the two drift apart.
 */
export const brandColors = {
  white: "#FFF",
  black: "#000",
  red1: "#FF4A31",
  redLight: "#FF806F",
  dark1: "#1D1D1F",
  grey1: "#1F1F23",
  grey2: "#29292C",
  grey3: "#353639",
  grey4: "#515359",
  grey5: "#A5A5A5",
  grey6: "#F2F2F2",
  grey7: "#4C4C4F",
  yellow1: "#FFF440",
  yellow2: "#FFF100",
  yellow3: "#FFF99B",
  yellow4: "#FFFCCA",
  yellow5: "#625E28",
  purple1: "#A855F7",
  warning: "#FFAB6F",
  /** Extraction doubt: a value that may be wrong, or a reference that did not
   *  resolve. Not "you have work here", which is `attention`. */
  doubt: "#FFAB6F",
  /** The reviewer is needed: work is waiting, but nothing is in question. */
  attention: "#FFF440",
  /** The hover and active step of `attention`. It IS needed here and not only in
   *  the CSS: `hover:bg-yellow2` exists in TSX today, so a Tailwind utility has to
   *  resolve for it. A CSS variable alone would emit nothing, which is exactly how
   *  the undefined colour in Task 1 shipped. */
  "attention-strong": "#FFF100",
  success: "#7ED321",
  completed: "#70E975",
} as const

export type BrandColor = keyof typeof brandColors
